<template>
  <b-modal
    id="card-selection-is-anonymous-error"
    show="isAnonymous"
    hide-header
    no-close-on-esc
    size="lg"
    static
  >
    <div class="title pb-4">
      <span class="h3">
        <font-awesome-icon
          icon="exclamation-triangle"
          class="text-danger"
        />
      </span>
      <span class="h3 pr-4">
        User Login Error
      </span>
    </div>
    <div class="error-message">
      <p>You cannot select stored credit cards for anonymous users.</p>
      <p>Please login to continue</p>
    </div>
  </b-modal>
</template>

<script>

export default {
  name: 'square-payment-card-selection-anonymous-error',
  props: {
    isAnonymous: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style>

</style>
